<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/hunter-lessons-schedule" class="sidebar__link">
      <img src="@/assets/img/group-icon-white.png" alt="" />
      <p>{{ $t("Sidebar.groups-list") }}</p>
    </router-link>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();
    const isTest = process.env.VUE_APP_MODAL_LOGIN;
    return {
      isTest,
      t,
    };
  },
};
</script>

<style></style>
